import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { Container, SectionLabel } from '../../design';
import { CtaBand } from '../Marketing/CtaBand';
import { MKT } from '../Marketing/links';
import { MarketingLayout } from '../Marketing/MarketingLayout';
import { blogPath, POSTS } from './posts';
import './blog.css';
const dateLabel = (d)=>new Date(`${d}T12:00:00Z`).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    });
function PostCard({ post }) {
    return /*#__PURE__*/ _jsxs("a", {
        href: blogPath(post.slug),
        className: "mk-blog__card",
        "data-testid": Testids.app.marketing.blogCard(post.slug),
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "mk-blog__card-k",
                "aria-hidden": "true",
                children: post.k
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "mk-blog__card-topic",
                children: post.topic
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "mk-blog__card-title",
                children: post.headline
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "mk-blog__card-excerpt",
                children: post.excerpt
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "mk-blog__card-meta",
                children: [
                    /*#__PURE__*/ _jsx("time", {
                        dateTime: post.published,
                        children: dateLabel(post.published)
                    }),
                    " · ",
                    post.minutes,
                    " min read"
                ]
            })
        ]
    });
}
/** /blog: every post, newest first. */ export function BlogIndex() {
    return /*#__PURE__*/ _jsxs(MarketingLayout, {
        testid: Testids.app.marketing.blogRoot,
        children: [
            /*#__PURE__*/ _jsx("main", {
                className: "mk-blog",
                children: /*#__PURE__*/ _jsxs(Container, {
                    children: [
                        /*#__PURE__*/ _jsx(SectionLabel, {
                            k: "記",
                            children: "Blog"
                        }),
                        /*#__PURE__*/ _jsx("h1", {
                            className: "mk-blog__title",
                            children: "Notes on importing JDM cars from Japanese auctions"
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "mk-blog__lead",
                            children: [
                                "Practical guides for import shops and dealers: reading auction sheets, grades, the 25-year rule, agents and what a car really costs once it lands. For the whole process end to end, start with the ",
                                /*#__PURE__*/ _jsx("a", {
                                    href: MKT.guide,
                                    children: "importing guide"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mk-blog__grid",
                            children: POSTS.map((p)=>/*#__PURE__*/ _jsx(PostCard, {
                                    post: p
                                }, p.slug))
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mk-blog__feed",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "/blog/feed.xml",
                                children: "RSS feed"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(CtaBand, {})
        ]
    });
}
/** /blog/<slug>: one post, with the posts around it. */ export function BlogArticle({ post }) {
    const others = POSTS.filter((p)=>p.slug !== post.slug).slice(0, 3);
    const { Body } = post;
    return /*#__PURE__*/ _jsxs(MarketingLayout, {
        testid: Testids.app.marketing.blogPostRoot(post.slug),
        children: [
            /*#__PURE__*/ _jsx("main", {
                className: "mk-post",
                children: /*#__PURE__*/ _jsxs(Container, {
                    className: "mk-post__wrap",
                    children: [
                        /*#__PURE__*/ _jsxs("nav", {
                            className: "mk-post__crumbs",
                            "aria-label": "Breadcrumb",
                            children: [
                                /*#__PURE__*/ _jsx("a", {
                                    href: MKT.home,
                                    children: "Home"
                                }),
                                " ",
                                /*#__PURE__*/ _jsx("span", {
                                    "aria-hidden": "true",
                                    children: "›"
                                }),
                                ' ',
                                /*#__PURE__*/ _jsx("a", {
                                    href: MKT.blog,
                                    children: "Blog"
                                }),
                                " ",
                                /*#__PURE__*/ _jsx("span", {
                                    "aria-hidden": "true",
                                    children: "›"
                                }),
                                ' ',
                                /*#__PURE__*/ _jsx("span", {
                                    "aria-current": "page",
                                    children: post.topic
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("article", {
                            children: [
                                /*#__PURE__*/ _jsxs("header", {
                                    className: "mk-post__head",
                                    children: [
                                        /*#__PURE__*/ _jsx(SectionLabel, {
                                            k: post.k,
                                            children: post.topic
                                        }),
                                        /*#__PURE__*/ _jsx("h1", {
                                            className: "mk-post__title",
                                            children: post.headline
                                        }),
                                        /*#__PURE__*/ _jsxs("p", {
                                            className: "mk-post__meta",
                                            children: [
                                                "Right Hand DMS · ",
                                                /*#__PURE__*/ _jsx("time", {
                                                    dateTime: post.published,
                                                    children: dateLabel(post.published)
                                                }),
                                                post.modified !== post.published && /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        ' ',
                                                        "· updated ",
                                                        /*#__PURE__*/ _jsx("time", {
                                                            dateTime: post.modified,
                                                            children: dateLabel(post.modified)
                                                        })
                                                    ]
                                                }),
                                                ' ',
                                                "· ",
                                                post.minutes,
                                                " min read"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mk-post__body",
                                    children: /*#__PURE__*/ _jsx(Body, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("aside", {
                            className: "mk-post__more",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "mk-post__more-title",
                                    children: "More from the blog"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mk-blog__grid",
                                    children: others.map((p)=>/*#__PURE__*/ _jsx(PostCard, {
                                            post: p
                                        }, p.slug))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(CtaBand, {})
        ]
    });
}
